export const lang = {
    test_data:'i18n internationalization',
    login: 'LOGIN',
    register: 'register',
    remember: 'remember',
    logout:'logout',
    home: 'home',
    about: 'about',
    aboutDesc: 'This is an about page',
    submit: 'submit',
    forget: 'forget',
    username: 'Username',
    password: 'Password',

}
